import React, { useEffect, useState } from "react";
import { Avatar, Flex } from "antd";
import { Layout } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import CustomImage from "../components/CustomImage";
import "./Layout.scss";

// import logo from "../assets/images/auth-logo.png";
import logo from "../assets/images/logo.svg";

import DashboardIcon from "../assets/images/home-icon.svg";
import ColoredDashboardIcon from "../assets/images/colored-home-icon.svg";

import SettingsIcon from "../assets/images/settings-icon.svg";
import ColoredSettingsIcon from "../assets/images/colored-settings-icon.svg";

import ShipmentIcon from "../assets/images/shipment-icon.svg";
import ColoredShipmentIcon from "../assets/images/colored-shipment-icon.svg";

import FlyingIcon from "../assets/images/flying-icon.svg";
import ColoredFlyingIcon from "../assets/images/colored-flying-icon.svg";

import { useToken } from "../common/helper";
import { useWebSocket } from "../context/WebSocketContext";
import ChatIcon from "../assets/images/ChatIcon";
import { useDispatch, useSelector } from "react-redux";
//import { fetchMenu } from "../reudx-toolkit/slice/menuSlice";

const { Sider } = Layout;

function CustomSidebar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { webSocketService } = useWebSocket();
  const { decodedUserToken, userID, token } = useToken();
  const [hasNewMessages, setHasNewMessages] = useState(false);
  let decodedToken = decodedUserToken();
  // Chatbot icons with JSX, assigned to variables
  const chatIcon = <ChatIcon color="white" fillcolor="#3D81FF" />;
  const coloredChatIcon = <ChatIcon color="#3D81FF" fillcolor="white" />;

  const iconMap = {
    DashboardIcon,
    ColoredDashboardIcon,
    SettingsIcon,
    ColoredSettingsIcon,
    ShipmentIcon,
    ColoredShipmentIcon,
    FlyingIcon,
    ColoredFlyingIcon,
    ChatIcon: chatIcon,
    ColoredChatIcon: coloredChatIcon,
  };

  // menu from redux/store
  const menuItems = useSelector((state) => state.menu.items);
  // console.log("main menu from server/store", menuItems);

  // const menuItems = [
  //   {
  //     key: permissionsMenu?.dashboard?.key || '/',
  //     label: "Home",
  //     icon: DashboardIcon,
  //     coloredIcon: ColoredDashboardIcon,
  //   },
  //   {
  //     key: permissionsMenu?.shipment?.key || '/',
  //     label: "Shipment",
  //     icon: ShipmentIcon,
  //     coloredIcon: ColoredShipmentIcon,
  //   },
  //   {
  //     key: permissionsMenu?.airportList?.key || '/',
  //     label: "Airports",
  //     icon: FlyingIcon,
  //     coloredIcon: ColoredFlyingIcon,
  //   },
  //   {
  //     key: permissionsMenu?.settings?.key || '/',
  //     label: "Settings",
  //     icon: SettingsIcon,
  //     coloredIcon: ColoredSettingsIcon,
  //   },
  //   {
  //     key: permissionsMenu?.chatbot?.key || '/',
  //     label: "Chatbot",
  //     icon: chatIcon,
  //     coloredIcon: coloredChatIcon,
  //   },
  // ];
  const visibleMenuItems = menuItems.filter(item => item.name !== "Chatbot"); // to remove later 

  const filteredMenuItems = visibleMenuItems.filter((item) => {
    const userRole = decodedToken?.role?.toLowerCase();
    const isAdminOrEditor = userRole === "admin" || userRole === "editor";
    const isChatbotRestricted =
      item.route === "chatbot" &&
      decodedToken?.company_name?.toLowerCase() !== "zoomlogi";

    return (
      isAdminOrEditor || item.route === "airport-list" || !isChatbotRestricted
    );
  });

  const location = useLocation();

  const [activeMenu, setActiveMenu] = useState("dashboard");
  const [hoveredMenu, setHoveredMenu] = useState(null);

  // useEffect(() => {
  //   const handleNewMessage = (data) => {
  //     try {
  //       const parsedData = JSON.parse(data);
  //       if (parsedData?.sender_id !== userID) {
  //         setHasNewMessages(true);
  //       }
  //     } catch (error) {
  //       console.error("❌ Error parsing WebSocket message:", error);
  //     }
  //   };

  //   webSocketService.onMessage(handleNewMessage);

  //   return () => {
  //     webSocketService.removeMessageListener(handleNewMessage);
  //   };
  // }, [webSocketService, userID]);

  useEffect(() => {
    const currentPath = location.pathname.split("/")[1];
    const activeItem = menuItems.find((item) => item.route === currentPath);
    setActiveMenu(activeItem ? activeItem.route : "dashboard");
    // dispatch(fetchMenu(token));
  }, [location]);

  const handleSetActiveMenu = (menuItem) => {
    // if (menuItem === "chatbot") {
    //   setHasNewMessages(false);
    // }
    setActiveMenu(menuItem);
    navigate(`/${menuItem}`);
  };

  const getIcon = (menuItem, defaultIcon, coloredIcon) => {
    const iconName =
      hoveredMenu === menuItem || activeMenu === menuItem
        ? coloredIcon
        : defaultIcon;
    return iconMap[iconName] || DashboardIcon; // fallback to DashboardIcon if not found
  };

  return (
    <>
      <div className="sidebar-content">
        <div className="logo">
          <Flex justify="center">
            <CustomImage src={logo} preview={false} />
          </Flex>
        </div>

        <ul className="menu">
          {filteredMenuItems.map((item) => {

            return (
              <li
                key={item.route}
                className={activeMenu === item.route ? "active" : ""}
                onClick={() => handleSetActiveMenu(item.route)}
                onMouseEnter={() => setHoveredMenu(item.route)}
                onMouseLeave={() => setHoveredMenu(null)}
                style={{ position: "relative" }}
              >
                <Flex vertical={true} justify="center" align="center" gap={4}>
                  <Flex
                    className="menu-item-icon"
                    align="center"
                    justify="center"
                    style={{ width: "36px", height: "36px" }}
                  >
                    {(() => {
                      const icon = getIcon(
                        item.route,
                        item.icon,
                        item.coloredIcon
                      );
                      return (
                        <Avatar
                        size={22}
                        src={typeof icon === "string" ? icon : undefined}
                        icon={typeof icon !== "string" ? icon : undefined}
                        style={
                          item.route === "chatbot"
                            ? {
                                backgroundColor:
                                  hoveredMenu === "chatbot" || activeMenu === "chatbot"
                                    ? "white"
                                    : "#3D81FF",
                              }
                            : {}
                        }
                      />
                      
                      );
                    })()}
                  </Flex>

                  {item.label}
                </Flex>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}

export default CustomSidebar;
